var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 21 22",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.69072 17.1611-1.0626 1.0553c-.92111.913-2.4192.9138-3.33978 0-.44258-.4392-.68565-1.0224-.68565-1.6425 0-.62.24333-1.2035.68538-1.6427l3.91125-3.8805c.8106-.8038 2.33547-1.98739 3.44688-.8852.51.5067 1.3338.5033 1.8401-.0065.5067-.50979.5035-1.33378-.0065-1.83988-1.8892-1.87477-4.68145-1.52827-7.11325.88463l-3.91151 3.88075c-.93844.9316-1.45504 2.1706-1.45504 3.4894s.5166 2.5576 1.4553 3.4892c.96574.9581 2.23387 1.4369 3.50254 1.4369 1.26892 0 2.53758-.4788 3.50385-1.4374l1.06338-1.0556c.50973-.5061.51263-1.3298.00604-1.8398-.50584-.5095-1.33035-.5124-1.84039-.0061zm11.85348-15.0745c-2.0292-2.0133654-4.8663-2.122565-6.7447-.25882l-1.3246 1.31486c-.51.50636-.5132 1.32982-.0065 1.83986.5066.51003 1.3303.51292 1.8403.00656l1.3241-1.31407c.9731-.96626 2.2473-.56569 3.0783.25882.4431.43916.6865 1.0227.6865 1.64272 0 .62029-.2436 1.20382-.6859 1.64298l-4.173 4.13959c-1.9081 1.8932-2.8032 1.0046-3.1852.6256-.51001-.5064-1.33348-.5032-1.8401.0065-.50663.5098-.50348 1.3338.00656 1.8399.87596.8694 1.87584 1.3004 2.92394 1.3004 1.2834 0 2.639-.6463 3.9278-1.926l4.173-4.13957c.9382-.93161 1.4553-2.17086 1.4553-3.48966 0-1.31827-.5171-2.55753-1.4558-3.48967z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link.cdcdf28cc53e68fc5ad92d1495cc22cc.svg";